import { AccountLayout } from "../../layouts";
import { CreateAnAccountForm } from "../../components/CreateAnAccount";

export const CreateAnAccountPage = () => {
  return <AccountLayout contents={<CreateAnAccountForm />} contentColumns={5} />;
};
